import { type UseQueryResult, useQuery } from 'react-query';
import {
  SandboxService,
  type Wealthlane_AppServices_Sandbox_SandboxResponseDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetSandboxById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<Wealthlane_AppServices_Sandbox_SandboxResponseDto | undefined, unknown> => {
  const sandboxById = useQuery(
    ['getSandboxById', id],
    async () => {
      if (id) {
        return await handleRequest(SandboxService.getApiIdentityApiSandbox1(id));
      }
    },
    {
      select(data) {
        return {
          ...data,
          sandboxType: data?.sandboxType === 'Empty' ? 1 : 2,
          visibility: data?.visibility === 'Public' ? 1 : 2,
        };
      },
    }
  );

  return sandboxById;
};

export default useGetSandboxById;
